module.exports = __webpack_public_path__ + "static/media/5.0789456d.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Guide/image/5.png
// module id = 6605
// module chunks = 0